import _ from "underscore";
import SelectOption from "ViewModels/selectOption";

export default {
  getConditionTypeSelectOptions: function (vesselFeatures, vessel) {
    var options = [
      new SelectOption("VesselDataOverdue", "vessel data is overdue"),
    ];
    var hasDiagnosticsFeature = _.any(vesselFeatures, function (feature) {
      return feature.name === "Diagnostics";
    });
    if (hasDiagnosticsFeature) {
      options.push(new SelectOption("PerformanceStatusObserve", "vessel performance status is Observe"));
      options.push(new SelectOption("PerformanceStatusNotOk", "vessel performance status is Not Ok"));
    }

    var hasKspSystem = vessel.onboardSystem.split(", ").includes("Ksp");
    if (hasKspSystem) {
      options.push(new SelectOption("ManualInputValueStale", "manual input has not been updated"));
    }

    options.push(new SelectOption("LogDataExpression", "log data matches custom logic expression"));

    return options;
  },
  getTargetKeySelectionOptions: function (conditionType) {
    switch (conditionType) {
      case "ManualInputValueStale":
        return [
          new SelectOption("meta:fuel-property", "fuel properties"),
          new SelectOption("property:draft", "draft"),
        ];

      default:
        return [];
    }
  },
  getConditionTypeText: function (condition) {
    switch (condition.conditionType) {
      case "VesselDataOverdue":
        return "Send alert if data has not been received from the vessel";
      case "DataAvailabilityStatus":
        return "Send alert if data availability status is Alert";
      case "PerformanceStatusObserve":
        return "Send alert if performance status is Observe";
      case "PerformanceStatusNotOk":
        return "Send alert if performance status is Not Okay";
      case "ManualInputValueStale": {
        switch (condition.targetKey) {
          case "meta:fuel-property":
            return "Send alert if fuel properties has not been updated";
          case "property:draft":
            return "Send alert if manual draft has not been updated";

          default:
            throw "Unexpected condition target key: " + condition.targetKey;
        }
      }
      case "LogDataExpression":
        return "Send alert if log data matches custom logic expression";
      case "LogDataMathExpression":
        return "Send alert if log data matches custom mathematical expression";
      case "ShapoliPowerReserveBreach":
        return "Send alert on ShaPoLi breach event";
      case "VoyageComplete":
        return "Send alert when voyage is complete";
      case "VariableOffline":
        return "Send alert when any feature or log variable is offline";
      case "MissingSignal":
        return "Send alert when any sensor signal is missing";
      case "SpeedLossWarning":
        return `Send alert if it is above defined threshold`;
      case "SpeedLossCritical":
        return `Send alert if it is above defined threshold`;
      case "FuelConsumptionWarning":
        return `Send alert if it is above defined threshold`;
      case "FuelConsumptionCritical":
        return `Send alert if it is above defined threshold`;
      default:
        throw "Unexpected condition type: " + conditionType;
    }
  },
  getTargetKeyByConditionType: function (conditionType) {
    switch (conditionType) {
      case "VesselDataOverdue":
        return "last-imported-date";
      case "DataAvailabilityStatus":
        return "DataAvailabilityStatus";
      case "PerformanceStatusObserve":
        return "perf-status-observe";
      case "PerformanceStatusNotOk":
        return "perf-status-notok";
      case "LogDataExpression":
        return "log-data-expression";
      case "LogDataMathExpression":
        return "LogDataMathExpression";
      case "ShapoliPowerReserveBreach":
        return "ShapoliPowerReserveBreach";
      case "VoyageComplete":
        return "VoyageComplete";
      case "VariableOffline":
        return "VariableOffline";
      case "MissingSignal":
        return "MissingSignal";
      case "SpeedLossWarning":
        return "SpeedLossWarning";
      case "SpeedLossCritical":
        return "SpeedLossCritical";
      case "FuelConsumptionWarning":
        return "FuelConsumptionWarning";
      case "FuelConsumptionCritical":
        return "FuelConsumptionCritical";
      default:
        return "";
    }
  },
  getConditionTimezoneText: function (condition) {
    switch (condition.conditionType) {
      case "VesselDataOverdue":
      case "PerformanceStatusObserve":
      case "PerformanceStatusNotOk":
      case "ManualInputValueStale":
        return "UTC";
      case "LogDataExpression":
        return "";
      default:
        throw "Unexpected condition type: " + condition.conditionType;
    }
  },
};
